export const RIGHT_RAIL_TABS_CONTAINER_ID = 'right-rail-tabs-container-id'
